// extracted by mini-css-extract-plugin
export var animationContainer = "_h4-0";
export var asteriskIcon = "_h4-8";
export var conversationLeftSection = "_h4-4";
export var conversationListItem = "_h4-3";
export var conversationMiddleSection = "_h4-5";
export var conversationRightSection = "_h4-6";
export var detailsContent = "_h4-1";
export var listContainer = "_h4-7";
export var modalContent = "_h4-2";